var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { findIndex, sortBy } from "lodash";
export function getRequiredTable(existingPreferences, containerType, containerId, tableId) {
    var _a;
    var existingWidgets = ((_a = existingPreferences === null || existingPreferences === void 0 ? void 0 : existingPreferences.preferences) === null || _a === void 0 ? void 0 : _a[containerType]) || [];
    var widgetIndex = findIndex(existingWidgets, { id: containerId });
    if (widgetIndex < 0)
        return undefined;
    var requiredWidget = existingWidgets[widgetIndex] || {};
    var widgetTables = (requiredWidget === null || requiredWidget === void 0 ? void 0 : requiredWidget.table) || [];
    var tableIndex = findIndex(widgetTables, { id: tableId });
    if (tableIndex < 0)
        return undefined;
    var requiredTable = widgetTables[tableIndex] || {};
    return requiredTable;
}
export function formatTablePreferences(existingPreferences, preferenceUpdates, containerType, containerId, tableId) {
    var _a;
    var existingWidgets = ((_a = existingPreferences === null || existingPreferences === void 0 ? void 0 : existingPreferences.preferences) === null || _a === void 0 ? void 0 : _a[containerType]) || [];
    var widgetIndex = findIndex(existingWidgets, { id: containerId });
    var requiredWidget = existingWidgets[widgetIndex] || {};
    var widgetTables = (requiredWidget === null || requiredWidget === void 0 ? void 0 : requiredWidget.table) || [];
    var tableIndex = findIndex(widgetTables, { id: tableId });
    var requiredTable = widgetTables[tableIndex] || {};
    var formattedTable = formatRequiredTable(tableId, requiredTable, preferenceUpdates);
    if (tableIndex > -1)
        widgetTables[tableIndex] = formattedTable;
    else
        widgetTables.push(formattedTable);
    requiredWidget.id = containerId;
    requiredWidget.table = widgetTables;
    if (widgetIndex > -1)
        existingWidgets[widgetIndex] = requiredWidget;
    else
        existingWidgets.push(requiredWidget);
    return existingWidgets;
}
function formatRequiredTable(tableId, existingTablePreferences, preferenceUpdates) {
    var paginationUpdates = preferenceUpdates === null || preferenceUpdates === void 0 ? void 0 : preferenceUpdates.pagination;
    var selectedPageSize = (paginationUpdates === null || paginationUpdates === void 0 ? void 0 : paginationUpdates.pageSize) ? paginationUpdates === null || paginationUpdates === void 0 ? void 0 : paginationUpdates.pageSize : paginationUpdates === null || paginationUpdates === void 0 ? void 0 : paginationUpdates.defaultPageSize;
    var table = __assign({ id: tableId, density: preferenceUpdates === null || preferenceUpdates === void 0 ? void 0 : preferenceUpdates.density, columns: formatTablePreferenceColumns(existingTablePreferences, preferenceUpdates) }, (selectedPageSize && { pagination: { pageSize: selectedPageSize } }));
    return table;
}
function formatTablePreferenceColumns(existingPreferences, preferences) {
    var _a;
    var columns = (preferences === null || preferences === void 0 ? void 0 : preferences.columnOrder) || [];
    var formattedColumns = [];
    var existingColumnMap = (_a = columnsToMap(existingPreferences === null || existingPreferences === void 0 ? void 0 : existingPreferences.columns)) === null || _a === void 0 ? void 0 : _a.columnMap;
    columns === null || columns === void 0 ? void 0 : columns.forEach(function (col) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var colKey = (_a = col === null || col === void 0 ? void 0 : col.key) === null || _a === void 0 ? void 0 : _a.toString();
        if (colKey) {
            var colObj = { id: colKey };
            if ((_b = preferences === null || preferences === void 0 ? void 0 : preferences.columnsToView) === null || _b === void 0 ? void 0 : _b.includes(colKey))
                colObj.isVisible = true;
            if (((_d = (_c = preferences === null || preferences === void 0 ? void 0 : preferences.sorters) === null || _c === void 0 ? void 0 : _c.column) === null || _d === void 0 ? void 0 : _d.key) === colKey)
                colObj.order = (_e = preferences === null || preferences === void 0 ? void 0 : preferences.sorters) === null || _e === void 0 ? void 0 : _e.order;
            else if (!(preferences === null || preferences === void 0 ? void 0 : preferences.sorters) && ((_f = existingColumnMap === null || existingColumnMap === void 0 ? void 0 : existingColumnMap[colKey]) === null || _f === void 0 ? void 0 : _f.order))
                colObj.order = (_g = existingColumnMap === null || existingColumnMap === void 0 ? void 0 : existingColumnMap[colKey]) === null || _g === void 0 ? void 0 : _g.order;
            if (Array.isArray((_h = preferences === null || preferences === void 0 ? void 0 : preferences.filters) === null || _h === void 0 ? void 0 : _h[colKey]))
                colObj.filter = (_j = preferences === null || preferences === void 0 ? void 0 : preferences.filters) === null || _j === void 0 ? void 0 : _j[colKey];
            else if (!(preferences === null || preferences === void 0 ? void 0 : preferences.filters) && ((_k = existingColumnMap === null || existingColumnMap === void 0 ? void 0 : existingColumnMap[colKey]) === null || _k === void 0 ? void 0 : _k.filter))
                colObj.filter = (_l = existingColumnMap === null || existingColumnMap === void 0 ? void 0 : existingColumnMap[colKey]) === null || _l === void 0 ? void 0 : _l.filter;
            if ((_m = preferences === null || preferences === void 0 ? void 0 : preferences.columnWidths) === null || _m === void 0 ? void 0 : _m[colKey])
                colObj.width = (_o = preferences === null || preferences === void 0 ? void 0 : preferences.columnWidths) === null || _o === void 0 ? void 0 : _o[colKey];
            else if ((_p = existingColumnMap === null || existingColumnMap === void 0 ? void 0 : existingColumnMap[colKey]) === null || _p === void 0 ? void 0 : _p.width)
                colObj.width = (_q = existingColumnMap === null || existingColumnMap === void 0 ? void 0 : existingColumnMap[colKey]) === null || _q === void 0 ? void 0 : _q.width;
            formattedColumns.push(colObj);
        }
    });
    return formattedColumns;
}
export function columnsToMap(existingColumns) {
    if (!existingColumns || !Array.isArray(existingColumns) || (existingColumns === null || existingColumns === void 0 ? void 0 : existingColumns.length) === 0)
        return { columnMap: {}, filteredFields: {} };
    var filteredFields = {};
    var columnMap = existingColumns.reduce(function (map, obj, indx) {
        var _a;
        if (((_a = obj === null || obj === void 0 ? void 0 : obj.filter) === null || _a === void 0 ? void 0 : _a.length) > 0)
            filteredFields[obj === null || obj === void 0 ? void 0 : obj.id] = obj === null || obj === void 0 ? void 0 : obj.filter;
        obj.index = indx;
        map[obj === null || obj === void 0 ? void 0 : obj.id] = obj;
        return map;
    }, {});
    var finaldata = {
        columnMap: columnMap,
        filteredFields: filteredFields
    };
    return finaldata;
}
export function formatColumns(columns, savedColumnMap, defaultVisibleColumns) {
    var sortedColumns = sortBy(columns, function (ob) {
        var _a;
        return (_a = savedColumnMap === null || savedColumnMap === void 0 ? void 0 : savedColumnMap[ob === null || ob === void 0 ? void 0 : ob.key]) === null || _a === void 0 ? void 0 : _a.index;
    });
    var finalColumnList = [], finalVisibleColumns = [];
    sortedColumns.forEach(function (col) {
        var _a, _b, _c, _d;
        var savedWidth = (_a = savedColumnMap === null || savedColumnMap === void 0 ? void 0 : savedColumnMap[col === null || col === void 0 ? void 0 : col.key]) === null || _a === void 0 ? void 0 : _a.width;
        var filters = (_b = savedColumnMap === null || savedColumnMap === void 0 ? void 0 : savedColumnMap[col.key]) === null || _b === void 0 ? void 0 : _b.filter;
        var order = (_c = savedColumnMap === null || savedColumnMap === void 0 ? void 0 : savedColumnMap[col.key]) === null || _c === void 0 ? void 0 : _c.order;
        if (savedWidth && savedWidth > 0)
            col.width = savedWidth;
        if (filters)
            col.defaultFilteredValue = filters;
        if (order)
            col.defaultSortOrder = order;
        finalColumnList.push(col);
        if ((_d = savedColumnMap === null || savedColumnMap === void 0 ? void 0 : savedColumnMap[col === null || col === void 0 ? void 0 : col.key]) === null || _d === void 0 ? void 0 : _d.isVisible)
            finalVisibleColumns.push(col === null || col === void 0 ? void 0 : col.key);
    });
    if ((finalVisibleColumns === null || finalVisibleColumns === void 0 ? void 0 : finalVisibleColumns.length) === 0 && defaultVisibleColumns && (defaultVisibleColumns === null || defaultVisibleColumns === void 0 ? void 0 : defaultVisibleColumns.length) > 0)
        finalVisibleColumns = defaultVisibleColumns;
    var finalData = {
        allColumns: finalColumnList,
        visibleColumns: finalVisibleColumns
    };
    return finalData;
}
export function getUpdatedColumnsMap(savedColumnMap, preferenceUpdates) {
    var _a;
    if (savedColumnMap && ((preferenceUpdates === null || preferenceUpdates === void 0 ? void 0 : preferenceUpdates.filters) || (preferenceUpdates === null || preferenceUpdates === void 0 ? void 0 : preferenceUpdates.sorters))) {
        var savedColumns_1 = __assign({}, savedColumnMap);
        (_a = Object.keys(savedColumns_1)) === null || _a === void 0 ? void 0 : _a.forEach(function (savedColKey) {
            var _a, _b, _c, _d, _e, _f;
            if ((_a = preferenceUpdates === null || preferenceUpdates === void 0 ? void 0 : preferenceUpdates.filters) === null || _a === void 0 ? void 0 : _a[savedColKey]) {
                savedColumns_1[savedColKey].filter = (_b = preferenceUpdates === null || preferenceUpdates === void 0 ? void 0 : preferenceUpdates.filters) === null || _b === void 0 ? void 0 : _b[savedColKey];
            }
            else if (savedColumns_1[savedColKey].filter) {
                savedColumns_1[savedColKey].filter = undefined;
            }
            if (((_d = (_c = preferenceUpdates === null || preferenceUpdates === void 0 ? void 0 : preferenceUpdates.sorters) === null || _c === void 0 ? void 0 : _c.column) === null || _d === void 0 ? void 0 : _d.key) === savedColKey && ((_e = preferenceUpdates === null || preferenceUpdates === void 0 ? void 0 : preferenceUpdates.sorters) === null || _e === void 0 ? void 0 : _e.order)) {
                savedColumns_1[savedColKey].order = (_f = preferenceUpdates === null || preferenceUpdates === void 0 ? void 0 : preferenceUpdates.sorters) === null || _f === void 0 ? void 0 : _f.order;
            }
            else if (savedColumns_1[savedColKey].order) {
                savedColumns_1[savedColKey].order = undefined;
            }
        });
        return savedColumns_1;
    }
    return savedColumnMap;
}
/**
 * table pagination utils
 */
var getColumnKey = function (column, index) {
    return column.key || column.dataIndex || index;
};
var treeMap = function (tree, mapper, childrenName) {
    if (childrenName === void 0) { childrenName = 'children'; }
    return tree.map(function (node, index) {
        var extra = {};
        if (node[childrenName]) {
            extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
        }
        return __assign(__assign({}, mapper(node, index)), extra);
    });
};
var findColumn = function (myKey, originalState) {
    var column;
    treeMap(originalState.columns, function (c) {
        if (getColumnKey(c) === myKey) {
            column = c;
        }
    });
    return column;
};
var recursiveSort = function (data, sorterFn, originalProps) {
    var _a = originalProps.childrenColumnName, childrenColumnName = _a === void 0 ? 'children' : _a;
    return data.sort(sorterFn).map(function (item) {
        var _a;
        return item[childrenColumnName]
            ? __assign(__assign({}, item), (_a = {}, _a[childrenColumnName] = recursiveSort(item[childrenColumnName], sorterFn, originalProps), _a)) : item;
    });
};
var getSorterFn = function (state, originalState) {
    var _a = state || originalState, sortOrder = _a.sortOrder, sortColumn = _a.sortColumn;
    if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
        return;
    }
    return function (a, b) {
        var result = sortColumn.sorter(a, b, sortOrder);
        if (result !== 0) {
            return sortOrder === 'descend' ? -result : result;
        }
        return 0;
    };
};
var getLocalData = function (state, filter, originalState, originalProps) {
    if (filter === void 0) { filter = true; }
    if (originalState === void 0) { originalState = {}; }
    if (originalProps === void 0) { originalProps = {}; }
    var currentState = state || originalState;
    var dataSource = originalProps.dataSource;
    var data = dataSource || [];
    data = data.slice(0);
    var sorterFn = getSorterFn(currentState, originalState);
    if (sorterFn) {
        data = recursiveSort(data, sorterFn, originalProps);
    }
    if (filter && currentState.filters) {
        Object.keys(currentState.filters).forEach(function (columnKey) {
            var col = findColumn(columnKey, originalState);
            if (!col) {
                return;
            }
            var values = currentState.filters[columnKey] || [];
            if (values.length === 0) {
                return;
            }
            var onFilter = col.onFilter;
            data = onFilter
                ? data.filter(function (record) {
                    return values.some(function (v) { return onFilter(v, record); });
                })
                : data;
        });
    }
    return data;
};
export var onPageSizeChange = function (tableInnerComponent, pageSize) {
    var state = tableInnerComponent.state, props = tableInnerComponent.props;
    var pagination = __assign(__assign({}, state.pagination), { pageSize: parseInt(pageSize), current: 1 });
    delete pagination.onChange;
    delete pagination.onShowSizeChange;
    var filters = state.filters;
    var sorter = {};
    var currentColumn = null;
    if (state.sortColumn && state.sortOrder) {
        currentColumn = state.sortColumn;
        sorter.column = state.sortColumn;
        sorter.order = state.sortOrder;
    }
    if (currentColumn) {
        sorter.field = currentColumn.dataIndex;
        sorter.columnKey = getColumnKey(currentColumn);
    }
    var extra = {
        currentDataSource: getLocalData(state, undefined, state, props),
    };
    return ({ pagination: pagination, filters: filters, sorter: sorter, extra: extra });
};
//# sourceMappingURL=table.js.map